import { render, staticRenderFns } from "./DonutChartProfitTeam.vue?vue&type=template&id=0cf10d22&scoped=true"
import script from "./DonutChartProfitTeam.js?vue&type=script&lang=js&external"
export * from "./DonutChartProfitTeam.js?vue&type=script&lang=js&external"
import style0 from "./DonutChartProfitTeam.vue?vue&type=style&index=0&id=0cf10d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf10d22",
  null
  
)

export default component.exports